const STORAGE_KEY = "backofficeNavCollapsed"

const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

const isCollapsed = () => document.documentElement.classList.contains("backoffice-nav-collapsed")

const syncToggle = (button) => {
  const collapsed = isCollapsed()
  const expandLabel = button.dataset.tooltipExpand || "Étendre le menu"
  const collapseLabel = button.dataset.tooltipCollapse || "Réduire le menu"
  const label = collapsed ? expandLabel : collapseLabel

  button.setAttribute("aria-expanded", collapsed ? "false" : "true")
  button.setAttribute("aria-label", label)
  button.setAttribute("data-tooltip", label)
}

const persistCollapsed = (collapsed) => {
  const url = document.documentElement.dataset.navCollapseUrl
  if (!url) return

  fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
      "X-Requested-With": "XMLHttpRequest"
    },
    body: JSON.stringify({ collapsed }),
    credentials: "same-origin"
  })
    .then((response) => {
      if (!response.ok) return
      document.documentElement.dataset.navCollapsePreferenceSet = "1"
      try {
        localStorage.removeItem(STORAGE_KEY)
      } catch (_error) {
        // ignore
      }
    })
    .catch(() => {
      // ignore network errors; UI state already updated
    })
}

export const setCollapsed = (collapsed, { persist = true } = {}) => {
  document.documentElement.classList.toggle("backoffice-nav-collapsed", collapsed)
  document.querySelectorAll("[data-backoffice-nav-toggle]").forEach(syncToggle)
  if (persist) persistCollapsed(collapsed)
}

const migrateLegacyLocalPreference = () => {
  if (document.documentElement.dataset.navCollapsePreferenceSet === "1") return

  let fromStorage = false
  try {
    fromStorage = localStorage.getItem(STORAGE_KEY) === "1"
  } catch (_error) {
    fromStorage = false
  }

  if (fromStorage || isCollapsed()) {
    persistCollapsed(isCollapsed())
  }
}

export const initBackofficeNavCollapse = () => {
  document.querySelectorAll("[data-backoffice-nav-toggle]").forEach(syncToggle)
  migrateLegacyLocalPreference()

  if (document.documentElement.dataset.backofficeNavCollapseInit === "true") return
  document.documentElement.dataset.backofficeNavCollapseInit = "true"

  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-backoffice-nav-toggle]")
    if (!button) return
    setCollapsed(!isCollapsed())
  })
}
